import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { Message } from 'element-ui'

// 后端 token 相关错误码（见 ResponseStatus.java）
// 2001 token缺失 / 2002 token校验失败 / 2003 token失效
const TOKEN_ERROR_CODES = [2001, 2002, 2003]

// 并发请求场景下避免多次弹窗 + 多次跳转
let redirecting = false
function handleTokenExpired(msg) {
  if (redirecting) return
  redirecting = true
  Message.closeAll()
  Message({ message: msg || '登录已失效，请重新登录', type: 'warning' })
  // 清空本地 token 与用户信息
  store.commit('REMOVE_INFO')
  // 延迟一点让用户看到提示后再跳
  setTimeout(() => {
    redirecting = false
    const current = router.currentRoute.fullPath
    router.push({ path: '/login', query: current && current !== '/login' ? { redirect: current } : {} })
  }, 400)
}

// 创建 axios 实例
const service = axios.create({
  baseURL: `${process.env.BASE_API ? process.env.BASE_API : '/api'}`
})

// request 拦截
service.interceptors.request.use(
  config => {
    if (store.state.token) {
      config.headers['token'] = window.sessionStorage.getItem('token')
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// response 拦截
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 200) {
      return response
    }
    // 业务码为 token 相关时，统一走失效流程
    if (TOKEN_ERROR_CODES.includes(res.code)) {
      handleTokenExpired(res.msg)
      return Promise.reject(res.msg)
    }
    Message({ message: res.msg, type: 'error' })
    return Promise.reject(res.msg)
  },
  error => {
    console.log(error)
    const status = error.response && error.response.status
    const data = (error.response && error.response.data) || {}
    const msg = data.msg || error.message

    // HTTP 401 / 403 也视为未授权
    if (status === 401 || status === 403 || TOKEN_ERROR_CODES.includes(data.code)) {
      handleTokenExpired(msg)
      return Promise.reject(msg)
    }
    Message({ message: msg, type: 'error' })
    return Promise.reject(msg)
  }
)

export default service
